import { useCallback, useEffect, useMemo, useState } from 'react';
import companyCityService from '../services/companyCityService';
import {
  findCityById,
  findCityByName,
  getDefaultCity,
  mapCitiesToOptions,
  resolveCompanyCity
} from '../utils/cityHelpers';

export function useCompanyCities({ activeOnly = true } = {}) {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    try {
      setLoading(true);
      setError('');
      const res = await companyCityService.list({ activeOnly });
      const rows = res?.data || [];
      setCities(mapCitiesToOptions(rows));
    } catch (err) {
      console.error('Chargement villes:', err);
      setError(err.message || 'Impossible de charger les villes');
      setCities([]);
    } finally {
      setLoading(false);
    }
  }, [activeOnly]);

  useEffect(() => {
    load();
  }, [load]);

  const defaultCity = useMemo(() => getDefaultCity(cities), [cities]);

  const resolveForCompany = useCallback(
    (company) => resolveCompanyCity(company, cities),
    [cities]
  );

  return {
    cities,
    loading,
    error,
    reload: load,
    defaultCity,
    findById: (id) => findCityById(cities, id),
    findByName: (name) => findCityByName(cities, name),
    resolveForCompany
  };
}

export default useCompanyCities;
